import {
  ref,
  reactive,
  getCurrentInstance,
  computed,
} from "@vue/composition-api";
import useFlatPickr from "@/utils/hooks/useFlatPickr";

export default function useInformation(props) {
  const {
    validFrom,
    validThrough,
    flatpickrDateConfig,
    flatpickrTimeConfig,
    resolveDateObject,
    resolveDate,
    resolveTime,
  } = useFlatPickr();

  const vm = getCurrentInstance().proxy;

  const activeHover = {
    QUIZ_NAME: 1,
    QUIZ_DESC: 2,
  };

  const customQuillOption = {
    theme: "snow",
    modules: {
      toolbar: "#my-toolbar",
      keyboard: {
        bindings: {
          "list autofill": {
            prefix: /•\\s\\d\\.\\s[A-z]/,
          },
        },
      },
    },
  };

  const nameNoHtml = computed(() =>
    props.formData.quizName.replace(/<[^>]*>/g, "")
  );

  const descNoHtml = computed(() =>
    props.formData.quizDesc
      ? props.formData.quizDesc.replace(/<[^>]*>/g, "")
      : ""
  );

  const onUploadBanner = (image) => {
    vm.$emit("onUploadBanner", image);
  };

  const onUploadDisplay = (image) => {
    vm.$emit("onUploadDisplay", image);
  };

  const activeQuizName = ref(true);
  const activeQuizDesc = ref(false);

  const toggleActive = (type) => {
    switch (type) {
      case activeHover.QUIZ_NAME:
        activeQuizName.value = true;
        activeQuizDesc.value = false;
        break;
      case activeHover.QUIZ_DESC:
        activeQuizName.value = false;
        activeQuizDesc.value = true;
        break;
      default:
        activeQuizName.value = false;
        activeQuizDesc.value = false;
    }
    vm.$emit("set-active");
  };

  const editorName = computed(() => vm.$refs.quizNameQuill.quill);
  const editorDesc = computed(() => vm.$refs.quizDescQuill.quill);

  const onFocusInput = (editor) => {
    editorName.value.focus();
    if (editor == "quizNameQuill") {
      editorName.value.focus();
    } else if (editor == "quizDescQuill") {
      editorDesc.value.focus();
    }
  };

  return {
    validFrom,
    validThrough,
    flatpickrDateConfig,
    flatpickrTimeConfig,
    resolveDateObject,
    resolveDate,
    resolveTime,

    onUploadBanner,
    onUploadDisplay,

    toggleActive,
    activeQuizName,
    activeQuizDesc,
    customQuillOption,
    activeHover,
    nameNoHtml,
    descNoHtml,
    onFocusInput,
  };
}
